import React, { useCallback } from 'react';
import loadable from '@loadable/component';

import ProductFilter from '../../../product/components/product-filter';
import ProductMap from '../../../product/components/product-map';
import ProductShowPlaceholder from '../../../product/components/product-show-placeholder';
import FilteredProductList from './filtered-product-list';
import { TILEVARIANT, GRIDLAYOUT } from '../utils';

import { Helpers } from '../../../core';

const GiftGuideTile = loadable(() => Helpers.retryFunc(() => import('../gift-guide-product-tile')));
const GiftGuideCard = loadable(() => Helpers.retryFunc(() => import('../gift-guide-product-card')));
const GGProductTile = loadable(() => Helpers.retryFunc(() => import('../ggproduct-tile')));

export default ({
    onAdd,
    enableAppPDP,
    products,
    prdFilterCondition,
    leftMenu,
    sortGtmActions,
    ToggleFilter,
    disableSearch,
    tabProps,
    enableGiftGuideVisIdTile,
    pg,
    productTileVariation,
    gridColumns = GRIDLAYOUT.classic,
}) => {
    const productMapClassName = gridColumns === GRIDLAYOUT.classic ? 'column-container' : `gg-col gg-${gridColumns}`;

    const createCustomProductCard = useCallback(
        (product, key, enableAppPDP, className, productIndex, placeholder) => {
            //pass in placehodler that has price component so that prices are available earlier and can filter OOS/NO IR
            if (placeholder) {
                return <ProductShowPlaceholder product={product} className="gift-guide-product-card" />;
            }
            const props = {
                product,
                onAdd: () => {
                    onAdd(product);
                },
                key,
            };

            switch (true) {
                case productTileVariation === TILEVARIANT.LifeStyleTile:
                    return <GGProductTile {...props} />;
                case productTileVariation === TILEVARIANT.visId || enableGiftGuideVisIdTile:
                    return <GiftGuideTile {...props} />;
                default:
                    //classic option in productTileVariation
                    return <GiftGuideCard {...props} />;
            }
        },
        [onAdd, productTileVariation],
    );

    if (!disableSearch) {
        return (
            <FilteredProductList
                productMapClassName={productMapClassName}
                leftMenu={leftMenu}
                createCustomProductCard={createCustomProductCard}
                enableAppPDP={enableAppPDP}
                ToggleFilter={ToggleFilter}
                sortGtmActions={sortGtmActions}
                prdFilterCondition={prdFilterCondition}
                disableSearch={disableSearch}
                tabProps={tabProps}
                pg={pg}
            />
        );
    }

    return (
        <ProductFilter products={products} condition={prdFilterCondition}>
            {filteredProducts => (
                <ProductMap
                    products={filteredProducts}
                    productItem={createCustomProductCard}
                    enableAppPDP={enableAppPDP}
                    lazyLoadPlaceHolderHeight={1040}
                    productItemClassName="gift-guide-product-card"
                    customPlaceHolder={true}
                    disableMultiContainers={true}
                    containerClassName={productMapClassName}
                />
            )}
        </ProductFilter>
    );
};
